export default "__VITE_ASSET__BxcmxZ90__"